<template>
    <div class="height-browser">
        <slot/>
    </div>
</template>

<script>
    export default {
        name: 'LayoutBase', //this is the name of the component   
    };
</script>

<style scoped>
/* .font-rounded { font-family: "Arial Rounded MT Bold"; font-size: 30px; } */

/*Page Login - height full*/
.basic-layout{
  height: 100% ;
}     

.height-browser{
  height: 10vh;
}


/* .btn-dark:focus {
  background-color: red !important;
}  */


/* .btn.btn-dark:active,
.btn.btn-dark:hover,
.btn.btn-dark:focus {
  background-color: #3A9275 !important;
  border-color: #3A9275 !important;
}


.custom-toggler.navbar-toggler {
    border-color: rgb(255,102,203);
}
.custom-toggler .navbar-toggler-icon {
  background-image: url("data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='white' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 8h24M4 16h24M4 24h24'/%3E%3C/svg%3E") !important;
} */
</style>
